import React from 'react'
import { CarMaintenanceTable } from '../component/carMaintenance/CarMaintenanceTable'

export const CarMaintenance = () => {
  return (
    <div><CarMaintenanceTable /></div>
  )
}
